import ExperienceComponent from './experience_component'
import React, { forwardRef } from 'react'
import './experience.scss'

// EXPERIENCE DATA GUIDE
// Add one object per organization. Add a startDate and, only when the engagement has ended, an endDate.
// Leave endDate blank/null for the current engagement and its duration will update automatically over time.
// Dates use YYYY-MM-DD so they remain easy to edit and unambiguous.
const experienceData = [
  {
    company: 'KPMG, India',
    imagePath: process.env.PUBLIC_URL + '/images/kpmg_office_2.webp',
    link: 'https://en.wikipedia.org/wiki/KPMG',
    summary:
      'Progressed across three roles within KPMG\'s Industry Intelligence practice, from technical internship through management internship to Associate Consultant.',
    roles: [
      {
        title: 'Assoc. Consultant',
        team: 'Industry Intelligence Team',
        location: 'Bangalore',
        startDate: "2026-06-11",
        endDate: null,
        period: 'Current',
        description:
          'Converted from internship through a performance-based Pre-Placement Offer and continued with the team as an Associate Consultant.'
      },
      {
        title: 'Management Intern',
        team: 'Industry Intelligence Team',
        location: 'Pune',
        startDate: "2025-05-01",
        endDate: "2025-09-01",
        period: 'Internship',
        description:
          'Worked under three Partners simultaneously on a cross-functional project in the Renewable Energy sector.'
      },
      {
        title: 'Technical Intern',
        team: 'Industry Intelligence Team',
        location: 'Mumbai',
        startDate: "2024-05-01",
        endDate: "2024-07-01",
        period: 'Internship',
        description:
          'Worked with KPMG\'s Industry 4.0 team as one of their first batch of interns. (Off-Campus Opportunity)'
      }
    ]
  }
]

const Experience = forwardRef((props, ref) => {
  return (
    <div className='experience_section' ref={ref}>
      <h1>Experience</h1>
      <div className='experience_org_list'>
        {experienceData.map((organization, index) => (
          <ExperienceComponent
            {...organization}
            key={`${organization.company}-${index}`}
          />
        ))}
      </div>
    </div>
  )
})

export default Experience
